import $ from 'jquery';
import 'jquery-datepicker';

function initDatepicker() {
    $('.js-jquery-datepicker').each((i, el) => {
        const $el = $(el);
        $el.datepicker({
            dateFormat: $el.data('date-format'),
            maxDate: $el.data('max-date') ? $el.data('max-date') : new Date(new Date().getFullYear(), 11, 31),
            minDate: $el.data('min-date') ? $el.data('min-date') : '-118y',
            yearRange: $el.data('year-range') ? $el.data('year-range') : 'c-118:c+118',
            showOtherMonths: true,
            changeMonth: true,
            changeYear: true,
            beforeShow: () => {
                $('#ui-datepicker-div').addClass('js-jquery-datepicker');
            },
            onClose: () => {
                $('#ui-datepicker-div').removeClass('js-jquery-datepicker');
            }
        });
    });


    const $btn = $('.js-jquery-datepicker-btn');
    $btn.click(function () {
        $(this).prev().datepicker('show');
        return false;
    });
}

// Run the functions on document ready
$(() => {
    initDatepicker();
});



// WEBPACK FOOTER //
// ./src/components/form-elements/c-datepicker.js